import { Button, Checkbox, Dialog, DialogContent, DialogTitle, FormControl, FormHelperText, Grid, IconButton, InputAdornment, InputLabel, makeStyles, MenuItem, OutlinedInput, Select, Switch, TextField, Tooltip } from "@material-ui/core";
import CloseIcon from '@material-ui/icons/Close';
import { withStyles } from "@material-ui/styles";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';
import { Autocomplete } from "@material-ui/lab";
import { useDispatch, useSelector } from "react-redux";
import { createNewDriver, deleteAccountDoc, editDriverBasic, editProfileAdditional, editSalaryType, getAccountDocument, getCountryList, getDeliveryAreas, getDriverAdditional, getDriverBasic, getProvinceList, getSalaryType, getVehicleTypes, postAccountDocument, getDeliveryAreasByWarehouse, getProvinceCountryByWarehouse, getDoubleCheck, deleteDoubleCheck, addDoubleCheck, getFuelTypes } from "../../../actions/driverAppApprovalActions";
import { addNewDriverTeam, getBasicInfo, getTeamList, handleDriverId } from "../../../actions/driverActions";
import { showAlertSnackbar } from "../../../reducers/uiSlice";
import { getUserPreference } from "../../../utilities/common";
import FullscreenLoading from '../../Common/FullscreenLoading';
import AddReplaceDocument from "../AddReplaceDocument";
import { driverDocUploadListCA, driverDocUploadListUS } from "../../../constants/general";
import { handleAddEditDriverDialog } from "../../../actions/driverActions";
import { useToken } from "../../../utilities/hooks";
import _ from 'lodash';
import Validation, { FormValidation } from "../../../utilities/formValidation";
import ResetPasswordDialog  from "./ResetPasswordDialog"
import moment from 'moment';

const ENABLE_DEACTIVATE_TEAM_MODIFY = 319;

const AntSwitch = withStyles((theme) => ({
    root: {
      width: 60,
      height: 24,
      padding: 0,
      display: 'flex',
    },
    switchBase: {
      padding: 3,
      color: theme.palette.grey[500],
      '&$checked': {
        transform: 'translateX(34px)',
        color: theme.palette.common.white,
        '& + $track': {
          opacity: 1,
          backgroundColor: theme.palette.primary.main,
          borderColor: theme.palette.primary.main,
        },
      },
    },
    thumb: {
      width: 20,
      height: 20,
      boxShadow: 'none',
    },
    track: {
      border: `1px solid ${theme.palette.grey[500]}`,
      borderRadius: 14,
      opacity: 1,
      backgroundColor: theme.palette.common.white,
    },
    checked: {},
}))(Switch);
const ColorButton = withStyles((theme) => ({
    root: {
        backgroundColor: 'none',
        width: '132px !important',
        borderRadius: 4,
        border: 'solid 2px #dd4b3f',
        color: '#dd4b3f',
        height: 42
    },
    disabled: {
        border: 'solid 2px #595959',
        color: '#595959 !important',
    }
}))(Button);
const OutlinedInputTop = withStyles((theme) => ({
    root: {
        '& .MuiOutlinedInput-notchedOutline': {
            borderBottom: 'none',
            borderBottomLeftRadius: 0,
            borderBottomRightRadius: 0
        }
    }
}))(OutlinedInput)
const OutlinedInputBetween = withStyles((theme) => ({
    root: {
        '& .MuiOutlinedInput-notchedOutline': {
            borderBottom: 'none',
            borderTop: 'none',
            borderBottomLeftRadius: 0,
            borderBottomRightRadius: 0,
            borderTopLeftRadius: 0,
            borderTopRightRadius: 0
        }
    }
}))(OutlinedInput)
const OutlinedInputBottom = withStyles((theme) => ({
    root: {
        '& .MuiOutlinedInput-notchedOutline': {
            borderTop: 'none',
            borderTopLeftRadius: 0,
            borderTopRightRadius: 0
        }
    }
}))(OutlinedInput)
const useStyles = makeStyles((theme) => ({
    titleStatus: {
        width: 152,
        padding: '5px 5px 6px 3px',
        borderRadius: 20,
        backgroundColor: '#262626',
        fontSize: 16,
        fontWeight: 'normal',
        color: '#8a8b8a',
        textAlign: 'center',
        marginLeft: 15
    },
    content: {
        paddingBottom: 45
    },
    info: {
        marginTop: 18
    },
    infoTitle: {
        fontSize: 18,
        fontWeight: 'bold',
        color: '#8a8b8a'
    },
    infoContent: {
        paddingTop: 28,
        paddingBottom: 24,
        borderBottom: 'solid 2.5px #636463'
    },
    photoGroup: {
        position: 'absolute',
        height: 90,
        width: 120,
        border: '#e4e4e3 solid 1px',
        backgroundColor: '#262626'
    },
    switch: {
        display: 'flex',
        justifyContent: 'space-between',
        width: 140,
        alignItems: 'center',
        marginTop: 8,
        marginLeft: 'auto',
        marginRight: 'auto'
    },
    supplies: {
        height: 46,
        marginTop: 26,
        borderRadius: 4,
        paddingTop: 16,
        paddingBottom: 12,
        border: 'solid 1.5px #e4e4e3',
        display: 'flex',
        justifyContent: 'space-evenly',
        textAlign: 'center'
    },
    supply: {
        width: 240,
        height: 38,
        borderRadius: 30,
        backgroundColor: '#e4e4e3',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: 2
    },
    supplyMinusAdd: {
        width: 36,
        height: 36,
        backgroundColor: '#262626',
        borderRadius: 18
    },
    addtionalTitle: {
        fontSize: 16,
        fontWeight: 'bold',
        color: '#fff',
        marginBottom: 15
    },
    buttonGroup: {
        marginTop: 29,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
    },
    dropdownStyle: {
        border: 'solid 2px #ff9d00',
        backgroundColor: '#262626'
    },
    menuItem: {
        borderTop: 'solid 2px #ff9d00',
        backgroundColor: '#262626'
    },
    formControl: {
        marginRight: 2,
        minWidth: 300,
    },
    labelStyle: {
        backgroundColor: theme.palette.background.paper,
        paddingLeft: theme.spacing(1),
        paddingRight: theme.spacing(1)
    }
}))

function AddEditDriver(props) {
    const classes = useStyles();
    const {t} = useTranslation('driverApproval');
    const dispatch = useDispatch();
    const userPref = getUserPreference();
    const tokenContents = useToken();
    const userUS = tokenContents.userUS;
    const enableDeactivateOrTeam = tokenContents.uiAbilities.includes(ENABLE_DEACTIVATE_TEAM_MODIFY);

    const uploadList = userUS ? driverDocUploadListUS : driverDocUploadListCA;
    const mobileRegex = /^\d{10}$/i;
    const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i;
    const routingNumberRegex = /^\d{9}$/i;
    let formValidation = new FormValidation();
    const openModal = useSelector(state => state.driver.openAddEditDriverDialog.open) || false;
    const openType = useSelector(state => state.driver.openAddEditDriverDialog.openType) || '';
    const vehicleList = useSelector(state => state.driverAppApproval.getVehicleType);
    const fuelList = useSelector(state => state.driverAppApproval.getFuelType)
    const countryProvince = useSelector(state => state.driverAppApproval.getProvinceCountryByWarehouse);

    const driverTypeList = [
        { label: t('full_time_driver'), value: -1 },
        { label: t('self_employee_driver'), value: 0 },
        { label: t('sorter'), value: 10}
    ];
    const SORTER = 10;
    const DEFAULT_PASSWORD = '7777';
    const DEFAULT_CLIENT = "LETIAN";
    const DEFAULT_BONUS = 0;
    const DEFAULT_AREA_COUNT = 3;
    const DEFAULT_SUPPLIES = [
        {
            item: 'Working Vest(s)',
            count: 0
        },
        {
            item: 'Hat(s)',
            count: 0
        },
        {
            item: 'Car Sticker(s)',
            count: 0
        }
    ];

    const CA_TO_US_TRANSFER_LIST = {
        'gst_number': 'tax_number',
        'sin_number': 'ssn_number'
    }
    const paramsRegexUni = {
        first_name: {
            maxLength: 32
        },
        last_name: {
            maxLength: 32
        },
        middle_name: {
            maxLength: 32
        },
        address: {
            maxLength: 128
        },
        city: {
            maxLength: 32
        },
        ZIP: {
            maxLength: 16
        },
        license_no: {
            maxLength: 24
        },
        vehicle_plate: {
            maxLength: 16
        },
        SSN_SIN: {
            maxLength: 24
        },
        contract_name: {
            maxLength: 32
        },
        contract_number: {
            maxLength: 24
        },
        account_holder: {
            maxLength: 32
        },
        account_number: {
            maxLength: userUS ? 17 : 12,
            minLength: 6
        },
        TAX_GST: {
            maxLength: 16
        },
        license_expiry_date: {
            maxLength: 10
        }
    }

    const [warehouseId, setWarehouseId] = useState(userPref.userCity);
    const [checkedSorting, setCheckedSorting] = useState(false);
    const [supplies, setSupplies] = useState(DEFAULT_SUPPLIES)
    const [suppliesStr, setSuppliesStr] = useState('');
    const [lastName, setLastName] = useState();
    const [firstName, setFirstName] = useState();
    const [middleName, setMiddleName] = useState();
    const [mobile, setMobile] = useState();
    const [email, setEmail] = useState();
    const [address, setAddress] = useState();
    const [licenseNum, setLicenseNum] = useState();
    const [vehiclePlate, setVehiclePlate] = useState();
    const [expiryDate, setExpiryDate] = useState(moment().format('YYYY-MM-DD'));
    const [vehicleType, setVehicleType] = useState();
    const [fuelType, setFuelType] = useState();
    const [sin, setSin] = useState();
    const [emergencyName, setEmergencyName] = useState();
    const [emergencyNum, setEmergencyNum] = useState();
    const [accountHolder, setAccountHoler] = useState();
    const [accountNum, setAccountNum] = useState();
    const [institution,setInstitution] = useState();
    const [transit, setTransit] = useState();
    const [gst, setGst] = useState();
    const [city, setCity] = useState();
    const [zip, setZip] = useState();
    const [country, setCountry] = useState();
    const [province, setProvince] = useState();
    const [deliveryAreaList, setDeliveryAreaList] = useState([]);

    const [photoAddOpen, setPhotoAddOpen] = useState(false);
    const [documentUploadList, setDocumentUploadList] = useState(uploadList);

    //the default option value when the salary type is "FIX"
    const [salaryTypeFix, setSalaryTypeFix] = useState();
    const [role, setRole] = useState(0);
    const [driverSalaryState,setDriverSalaryState] = useState([]);
    const [driverSalaryTypeFixList,setDriverSalaryTypeFixList] = useState([]);

    // add driver team attribute
    const [team, setTeam] = useState(0);
    const [customizeTeam, setCustomizeTeam] = useState('');
    const [teamAlias, setTeamAlias] = useState('');
    const [disableList, setDisableList] = useState(false);
    const [leaderChecked, setLeaderChecked] = useState(false);
    const [teamLeader, setTeamLeader] = useState(0);
    const [teamList, setTeamList] = useState([]);

    const [driverProfile, setDriverProfile] = useState({});
    const [driverAdditional, setDriverAdditional] = useState({});
    const [driverSalary, setDriverSalary] = useState([]);

    const [loading, setLoading] = useState(false);
    const [username, setUsername] = useState();
    const [accountId, setAccountId] = useState();
    const [isHired, setIsHired] = useState();
    const [backgroundChecked, setBackgroundChecked] = useState(0);
    
    const [paramsRegex, setParamsRegex] = useState(paramsRegexUni);
    const [paramsRegexValidate, setParamsRegexValidate] = useState(true);

    const [paramsValidition, setParamsValidition] = useState({});
    const [validateRes, setValidateRes] = useState({});
    const [openResetPasswordDialog, setOpenResetPasswordDialog] = useState(false);

    const [doubleCheck, setDoubleCheck] = useState(false);

    const isExpiryDateValid = (date) => {
        const max = moment().add(10, "year");
        const min = moment();
        const current = moment(date);
        if(current.isAfter(max) || current.isBefore(min)) {
            dispatch(showAlertSnackbar({message:t('invalid_expiry_date'),type:'error'}))
            return false;
        }
        return true;
    }

    const handleClose = () => {
        dispatch(handleAddEditDriverDialog(false));
    };
    const handleResetpasswordDialogClose = () => {
      setOpenResetPasswordDialog(false);
    };

    function handleSortingChange() {
        let checkedCopy = checkedSorting;
        setCheckedSorting(!checkedCopy);
    }
    function handleSupply(index, supply, addMinus) {
        let suppliesCopy = JSON.parse(JSON.stringify(supplies));
        let supplyCopy = JSON.parse(JSON.stringify(supply));
        if(addMinus === -1 && supplyCopy.count === 0) {
            return;
        }
        supplyCopy.count += addMinus;
        suppliesCopy[index] = supplyCopy;
        setSupplies(suppliesCopy);
    }
    function init() {
        setLastName();
        setFirstName();
        setMiddleName();
        setMobile();
        setEmail();
        setAddress();
        setCity();
        setZip();
        setLicenseNum();
        setVehiclePlate();
        setVehicleType();
        setFuelType();
        setSin();
        setAccountHoler();
        setAccountNum();
        setInstitution();
        setTransit();
        setGst();
        setEmergencyName();
        setEmergencyNum();
        setDocumentUploadList(uploadList);
        setIsHired(1);
        setSupplies(DEFAULT_SUPPLIES);

        setRole(0);
        setCheckedSorting(false);
        setSalaryTypeFix('FIX_');
        setTeam(0);
        setCustomizeTeam('');
        setTeamAlias('');
        setLeaderChecked(false);
        setTeamLeader(0);
        setBackgroundChecked(0);
        setDoubleCheck(false);
    }
    function checkMissing(params) {
        let missingParam = '';
        for(var key in params) {
            if(params[key] === 0) {
                continue;
            } else if(!params[key] && key !== 'gst_number' && key !== 'team_id' && key !== 'middle_name') {
                // US-BRANCH-OFF
                if(userUS) {
                    if(CA_TO_US_TRANSFER_LIST[key]) {
                        missingParam += ', ' + CA_TO_US_TRANSFER_LIST[key];
                    } else {
                        missingParam += ', ' + key;
                    }
                } else {
                  missingParam += ', ' + key;  
                }
            }
        }
        if(missingParam) {
            missingParam = missingParam.substring(1);
            dispatch(showAlertSnackbar({message: missingParam + t('missing') , type: 'error'}))
            return false;
        }
        return params;
    }
    function createParamsBasic() {
        if(!mobileRegex.test(emergencyNum)) {
            dispatch(showAlertSnackbar({message: t('emergency_phone_regex'), type: 'error'}))
            return;
        }
        if(!emailRegex.test(email)) {
            dispatch(showAlertSnackbar({message: t('email_regex'), type: 'error'}))
            return;
        }
        // US-BRANCH-OFF
        if(userUS) {
            if(!routingNumberRegex.test(transit)) {
                dispatch(showAlertSnackbar({message: t('routing_regex'), type: 'error'}))
                return;
            }
        }
        
        let params = {};
        params['warehouse_id'] = warehouseId;
        params['first_name'] = firstName;
        params['middle_name'] = middleName;
        params['last_name'] = lastName;
        params['phone'] = mobile;
        params['email'] = email;
        params['address'] = address;
        params['city'] = city;
        params['country'] = country;
        params['postal_code'] = zip;
        params['license_number'] = licenseNum;
        params['vehicle_plate'] = vehiclePlate;
        params['license_expiry_date'] = expiryDate;
        params['vehicle_type'] = vehicleType;
        params['vehicle_fuel_type'] = fuelType;
        params['sin_number'] = sin;
        params['emergency_contact_name'] = emergencyName;
        params['emergency_contact_number'] = emergencyNum;
        params['account_holder_name'] = accountHolder;
        params['account_number'] = accountNum;
        
        params['gst_number'] = gst;
        params['province'] = province;

        // US-BRANCH-OFF
        if(userUS) {
            params['bank_name'] = institution;
            params['routing_number'] = transit;
        } else {
            params['institution_number'] = institution;
            params['transit_number'] = transit;
        }
        return checkMissing(params);
    }
    function createParamsAdditional(teamIdParam) {
        let params = {} 
        params['role'] = role;
        params['supplies'] = suppliesStr;
        if(!checkedSorting) {
            params['bossflg'] = 0
        } else {
            params['bossflg'] = 1
        }
        params['team_leader'] = teamLeader;
        params['team_id'] = teamIdParam;
        params['is_hired'] = isHired;
        params['background_check_status'] = backgroundChecked;
        return checkMissing(params);
    }
    function handlePhotoAddClose() {
        setPhotoAddOpen(false);
    }
    function handleUploadDocument(list) {
        setDocumentUploadList(list)
    }
    function handleSubmit() {
        let paramsBasic = createParamsBasic();
        let paramsAdditional = createParamsAdditional(0);
        let salaryTypeArr = salaryTypeParam();
        if(!paramsBasic || !paramsAdditional || !salaryTypeArr) {
            return;
        }
        if(!paramsRegexValidate) {
            dispatch(showAlertSnackbar({message: 'Please modify inputs as indicated!', type: 'error'}));
            return;
        }
        setLoading(true);
        if(accountId) {
            doAddDriverInfo(accountId);
        } else {
            handleCreateDriver(false);
        }
    }
    function salaryTypeParam() {
        let salaryTypeArr = [];
        driverSalaryState.map((item)=>{
            if (item.label === "FIX" && item.checked === true) {
                salaryTypeArr.push({
                    income_type: salaryTypeFix,
                    client: DEFAULT_CLIENT,
                    performance_bonus: DEFAULT_BONUS
                });   
            } else {
                if (item.checked === true) {
                    salaryTypeArr.push({
                        income_type: item.value,
                        client: DEFAULT_CLIENT,
                        performance_bonus: DEFAULT_BONUS
                    }) ;
                }
            }
        });
        if(salaryTypeArr.length === 0) {
            dispatch(showAlertSnackbar({message: t('missing_salary'), type: 'error'}))
            return false;
        }
        return salaryTypeArr;
    }
    async function editDriver(accountId, teamId) {
        let teamIdParam = teamId || team;
        let paramsBasic = createParamsBasic();
        let paramsAdditional = createParamsAdditional(teamIdParam);
        let salaryTypeArr = salaryTypeParam();

        if(!paramsBasic || !paramsAdditional || !salaryTypeArr) {
            return;
        }
        documentUploadList.map((document) => {
            if (document.document) {
                if(typeof document.document === "object") {
                    handleDocumentUpload(accountId, document)
                }
            } else {
                dispatch(deleteAccountDoc(accountId, document.id))
            }
        })

        if (openType === 'update') {
            paramsBasic['action'] = 1;
        }

        try {
            await dispatch(editDriverBasic(accountId, paramsBasic))
            .catch(() => {
                dispatch(showAlertSnackbar({message: 'Failed to edit basic info!', type: 'error'}))
            })
            await dispatch(editProfileAdditional(accountId, paramsAdditional))
            .catch(() => {
                dispatch(showAlertSnackbar({message: 'Failed to edit additional info!', type: 'error'}))
            })
            if (doubleCheck) {
                dispatch(addDoubleCheck(accountId, userPref.username))
            } else {
                dispatch(deleteDoubleCheck(accountId, userPref.username))
            }
            await dispatch(editSalaryType(accountId, salaryTypeArr))
            .catch(() => {
                dispatch(showAlertSnackbar({message: 'Failed to edit salary!', type: 'error'}))
            })
            dispatch(handleDriverId(accountId))
            setTimeout(() => {
                dispatch(showAlertSnackbar({message: 'Driver ID: ' + `${accountId}`, type: 'success'}))
                handleClose();
            }, 300)
        } catch (err) {
            dispatch(showAlertSnackbar({message: 'Driver ID: ' + `${accountId}` + ', failed to save driver information.', type: 'warning'}))
        } finally {
            setLoading(false);
        }
    }
    function doAddDriverInfo(accountId) {
        if(customizeTeam) {
            if (!teamAlias && userUS) {
                setLoading(false);
                dispatch(showAlertSnackbar({ message: t('team_alias_missing'), type: 'error' }));
                return;
            } else {
                dispatch(addNewDriverTeam(customizeTeam, userPref.userCity, teamAlias))
                    .then(() => {
                        dispatch(getTeamList(userPref.userCity))
                            .then((res) => {
                                let teamListTemp = res.data;
                                teamListTemp.map((teamTemp) => {
                                    if (teamTemp.name === customizeTeam) {
                                        editDriver(accountId, teamTemp.id);
                                    }
                                })
                            })
                    })
            }
        } else {
            editDriver(accountId, undefined);
        }
    }
    function handleCreateDriver(isDocUpload) {
        if(mobileRegex.test(mobile)) {
            dispatch(createNewDriver(mobile, DEFAULT_PASSWORD))
            .then((res) => {
                if(isDocUpload) {
                    setAccountId(res.account_id);
                } else {
                    doAddDriverInfo(res.account_id);
                }
                setLoading(false);
            })
            .catch(() => {
                setPhotoAddOpen(false);
                dispatch(showAlertSnackbar({message: t('phone_exist'), type: 'error'}))
                setLoading(false);
            })
        } else {
            setPhotoAddOpen(false);
            dispatch(showAlertSnackbar({message: t('phone_regex'), type: 'error'}))
            setLoading(false);
        }
    }
    function handleAccountStatusChange() {
        if(isHired) {
            setIsHired(0);
        } else {
            setIsHired(1);
        }
    }
    function handleDocumentDownload() {
        dispatch(getAccountDocument(props.driverId))
        .then((res) => {
            let copy = JSON.parse(JSON.stringify(uploadList));
            uploadList.map((item, index) => {
                res.map((document) => {
                    if(item.id === document.doc_type) {
                        copy[index].document = document.access_url;
                        copy[index].preview = document.access_url;
                        copy[index].access_url = document.access_url;
                    }
                })
            })
            setDocumentUploadList(copy);
        })
        .catch(() => {
            setDocumentUploadList(uploadList);
        })
    }
    function handleDocumentUpload(accountId, document) {
        let formData = new FormData();
        
        formData.append('doc_file[]', document.document);
        formData.append('doc_type[]', document.id);
        dispatch(postAccountDocument(accountId, formData))
        .catch(() => {
            dispatch(showAlertSnackbar({message: t('upload_fail'), type: 'error'}));
        })
        return;
    }
    async function getAccountInfo() {
        try {
            await dispatch(getBasicInfo());
            await dispatch(getVehicleTypes());
            await dispatch(getFuelTypes());
            let teamlist = await dispatch(getTeamList(userPref.userCity));
            let teamListTemp = [{id: 0, name: "No Team"}];
            if(teamlist.data) {
                if(teamlist.data.length > 0) {
                    teamListTemp.splice(1, 0, ...teamlist.data);
                }
            }
            setTeamList(teamListTemp);
            if(openType === 'update') {
                let profile = await dispatch(getDriverBasic(props.driverId));
                setDriverProfile(profile);
                let profileAdditional = await dispatch(getDriverAdditional(props.driverId))
                setDriverAdditional(profileAdditional);
                let salary = await dispatch(getSalaryType(props.driverId));
                setDriverSalary(salary);
                handleDocumentDownload();
            }
        } finally {
            setLoading(false);
        }
    }
    const formValidate = async () => {
        formValidation.addValidation(new Validation(lastName, "last_name").maxChar(paramsRegex['last_name'].maxLength));
        formValidation.addValidation(new Validation(firstName, "first_name").maxChar(paramsRegex["first_name"].maxLength));
        formValidation.addValidation(new Validation(middleName, "middle_name").maxChar(paramsRegex["middle_name"].maxLength));
        formValidation.addValidation(new Validation(address, "address").maxChar(paramsRegex["address"].maxLength));
        formValidation.addValidation(new Validation(city, "city").maxChar(paramsRegex["city"].maxLength));
        formValidation.addValidation(new Validation(zip, "ZIP").maxChar(paramsRegex["ZIP"].maxLength));
        formValidation.addValidation(new Validation(licenseNum, "license_no").maxChar(paramsRegex["license_no"].maxLength));
        formValidation.addValidation(new Validation(vehiclePlate, "vehicle_plate").maxChar(paramsRegex["vehicle_plate"].maxLength));
        formValidation.addValidation(new Validation(expiryDate, "license_expiry_date").maxChar(paramsRegex["license_expiry_date"].maxLength));
        formValidation.addValidation(new Validation(sin, "SSN_SIN").maxChar(paramsRegex["SSN_SIN"].maxLength));
        formValidation.addValidation(new Validation(accountHolder, "account_holder").maxChar(paramsRegex["account_holder"].maxLength));
         formValidation.addValidation(new Validation(accountNum, "account_number").maxChar(paramsRegex["account_number"].maxLength).minChar(paramsRegex["account_number"].minLength).isDigit());
        if(userUS) {
            formValidation.addValidation(new Validation(institution, "bank_name_institution_number").maxChar(paramsRegex?.bank_name_institution_number?.maxLength));
        } else {
            formValidation.addValidation(new Validation(institution, "bank_name_institution_number").maxChar(paramsRegex?.bank_name_institution_number?.exactLength).minChar(paramsRegex?.bank_name_institution_number?.exactLength).isDigit());
        }
        formValidation.addValidation(new Validation(transit, "routing_number_transit_number").maxChar(paramsRegex?.routing_number_transit_number?.exactLength).minChar(paramsRegex?.routing_number_transit_number?.exactLength).isDigit());
        formValidation.addValidation(new Validation(gst, "TAX_GST").maxChar(paramsRegex["TAX_GST"].maxLength));
        formValidation.addValidation(new Validation(emergencyName, "contract_name").maxChar(paramsRegex["contract_name"].maxLength));

        try {
            setParamsValidition(formValidation);
            return formValidation.validate();
        } catch (error) {
            throw error
        }
    } 

    useEffect(() => {
        if(countryProvince) {
            if(countryProvince.length > 0) {
                const countryObj = countryProvince.find(element => element.level === 0);
                const provinceObj = countryProvince.find(element => element.level === 1);
                setCountry(countryObj.code);
                setProvince(provinceObj.code);
            }
        }
    }, [countryProvince])
    useEffect(() => {
        if(openModal) {
            init();
            setLoading(true);
            if(openType === 'add') {
                setAccountId('')
            } else {
                setAccountId(props.driverId);
                dispatch(getDoubleCheck(props.driverId))
                    .then((res) => {
                        setDoubleCheck(res.state)
                    })
                    .catch(() => {
                        dispatch(showAlertSnackbar({ message: t('fetch_fail'), type: 'error' }))
                    })
            }
            getAccountInfo();
            setDriverSalaryTypeFixList(props.driverSalaryTypeFixList);
            setDriverSalaryState(props.driverSalaryState);
        }
    }, [openModal])
    useEffect(() => {
        if(supplies) {
            if(supplies.length > 0) {
                setSuppliesStr(JSON.stringify(supplies))
            }
        }
    }, [supplies])
    useEffect(() => {
        dispatch(getDeliveryAreasByWarehouse(userPref.userCity))
        .then((res) => {
            setDeliveryAreaList(res);
        })
    }, [])
    useEffect(() => {
        if(role === 10) {
            setCheckedSorting(true);
        } else {
            setCheckedSorting(false);
        }
    }, [role])
    useEffect(() => {
        if(openType === 'update' && driverProfile) {
            let basis = driverProfile.basis;
            let driver = driverProfile.driver;
            let payout = driverProfile.payout;
            if(basis) {
                setLastName(basis.last_name);
                setFirstName(basis.first_name);
                setMiddleName(basis.middle_name);
                setMobile(basis.phone);
                setEmail(basis.email);
                setAddress(basis.address);
                setZip(basis.postal_code);
                setCity(basis.city);
                if(basis.province) {
                    setProvince(basis.province);
                }
                if(basis.country) {
                    setCountry(basis.country);
                }
            }
            if(driver) {
                setLicenseNum(driver.license_number);
                setVehiclePlate(driver.vehicle_plate);
                setVehicleType(driver.vehicle_type);
                setFuelType(driver.vehicle_fuel_type)
                setSin(driver.sin_number);
                setEmergencyName(driver.emergency_contact_name);
                setEmergencyNum(driver.emergency_contact_number);
                setExpiryDate(driver.license_expiry_date);
            }
            if(payout) {
                setAccountHoler(payout.account_holder_name);
                setAccountNum(payout.account_number);
                setInstitution(payout.institution_number || payout.bank_name);
                setTransit(payout.transit_number || payout.routing_number);
                setGst(payout.gst_number);
            }
        }
    }, [driverProfile])
    useEffect(() => {
        if(openType === 'update' && driverAdditional) {
            if(driverAdditional.bossflg) {
                setCheckedSorting(true);
            } else {
                setCheckedSorting(false);
            }
            setRole(driverAdditional.role);
            if(driverAdditional.supplies) {
                let copy = JSON.parse(JSON.stringify(DEFAULT_SUPPLIES));
                let num0 = (driverAdditional.supplies.match(new RegExp("反光衣", "g")) || []).length;
                let num1 = (driverAdditional.supplies.match(new RegExp("帽子", "g")) || []).length;
                let num2 = (driverAdditional.supplies.match(new RegExp("车贴", "g")) || []).length;
                let num3 = (driverAdditional.supplies.match(new RegExp("保温箱", "g")) || []).length;
                if(num0 || num1 || num2 || num3) {
                    copy[0].count = num0;
                    copy[1].count = num1;
                    copy[2].count = num2;
                    setSupplies(copy);
                } else {
                    let suppliesArr = JSON.parse(driverAdditional.supplies);
                    setSupplies(suppliesArr);
                }
            } else {
                setSupplies(DEFAULT_SUPPLIES);
            }
            setTeam(driverAdditional.team_id);
            setTeamLeader(driverAdditional.team_leader);
            setUsername(driverAdditional.username);
            setIsHired(driverAdditional.is_hired);
            setBackgroundChecked(driverAdditional.background_check_status);
        }
    }, [driverAdditional])
    useEffect(() => {
        if(openType === 'update' && driverSalary) {
            if(driverSalary.length > 0) {
                if (typeof(driverSalary) !== "undefined" && driverSalary.length > 0) {                
                    let salaryFixArr = driverSalary.filter((item)=>(item.income_type).indexOf("FIX_") >=0);
                    let salaryList = [];                                        
                    for (let i in driverSalaryState)  {
                        let isMatch = false;
                        if (driverSalaryState[i].value === "FIX" && (salaryFixArr!== null && salaryFixArr.length > 0)) {
                            salaryList.push({label: driverSalaryState[i].value, value: driverSalaryState[i].value, checked: true});
                            isMatch = true;
                        }
                        for (let j in driverSalary) {
                            if (driverSalaryState[i].value === driverSalary[j].income_type) {
                                salaryList.push({label: driverSalaryState[i].value, value: driverSalaryState[i].value, checked: true});
                                isMatch = true;    
                                break;
                            }
                        }
                        if (!isMatch) {
                            salaryList.push({label: driverSalaryState[i].value, value: driverSalaryState[i].value, checked: false});
                        }
                    }
                    setDriverSalaryState(salaryList);
    
                    if (salaryFixArr && salaryFixArr.length > 0) {
                        driverSalaryTypeFixList.map((item)=>{
                            if (item.value === salaryFixArr[0]['income_type']) 
                                setSalaryTypeFix(item.value);
                        });                 
                    }
                }
            }
        }
    }, [driverSalary])
    useEffect(() => {
        let paramsRegexClone = _.cloneDeep(paramsRegex);
        if(userUS) {
            paramsRegexClone.bank_name_institution_number = {
                maxLength: 64
            }
            paramsRegexClone.routing_number_transit_number = {
                exactLength: 9
            }
        } else {
            paramsRegexClone.bank_name_institution_number = {
                exactLength: 3
            }
            paramsRegexClone.routing_number_transit_number = {
                exactLength: 5
            }
        }
        setParamsRegex(paramsRegexClone);
    }, [userUS])

    useEffect(() => {
        if(formValidate() === true) {
            setParamsRegexValidate(true);
        } else {
            setParamsRegexValidate(false);
        }
    }, [paramsRegex, lastName, firstName, middleName, address, city, zip, licenseNum, vehiclePlate, sin, accountHolder, accountNum, institution, transit, gst, expiryDate])
    useEffect(() => {
        let validateResTemp = {};
        let valid = true;
        if(paramsValidition?.validateValues?.length) {
            paramsValidition?.validateValues.map((param) => {
                if(param.validationError.errors.length > 0) {
                    validateResTemp[param.fieldName] = false;
                    valid = false;
                } else {
                    validateResTemp[param.fieldName] = true;
                }
            })
        }
        setParamsRegexValidate(valid);
        setValidateRes(validateResTemp);
    }, [paramsValidition])

    return (
        <Dialog
            open={openModal}
            onClose={handleClose}
            maxWidth='lg'
            fullWidth
        >
            <DialogTitle>
                <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                    <div style={{display: 'flex', alignItems: 'baseline'}}>
                        <span>{openType === 'update' ? t('edit_exist_driver_sorter') : t('add_new_driver_sorter')}</span>
                    </div>
                    <Tooltip title={t('common:cancel')} aria-label="cancel">
                        <CloseIcon onClick={handleClose}></CloseIcon>
                    </Tooltip>
                </div>
            </DialogTitle>
            <DialogContent dividers  className={classes.content}>
                <div className={classes.info}>
                    <div className={classes.infoContent}>
                        <Grid container spacing={3}>
                            <Grid item xs={3}>
                                <FormControl fullWidth variant="outlined">
                                    <InputLabel
                                        style={{
                                            backgroundColor: '#424242',
                                            paddingLeft: 10,
                                            paddingRight: 10
                                        }}
                                        shrink={true}
                                    >
                                    {t('last_name')}
                                    </InputLabel>
                                    <OutlinedInput 
                                        value={lastName}
                                        onChange={(e) => {
                                            setLastName(e.target.value)
                                        }}
                                    />
                                    { !validateRes['last_name'] && 
                                        <FormHelperText error>
                                            MAX LENGTH: {paramsRegex['last_name'].maxLength}
                                        </FormHelperText>
                                    }
                                </FormControl>
                            </Grid>
                            <Grid item xs={3}>
                                <FormControl fullWidth variant="outlined">
                                    <InputLabel
                                        style={{
                                            backgroundColor: '#424242',
                                            paddingLeft: 10,
                                            paddingRight: 10
                                        }}
                                        shrink={true}
                                    >
                                    {t('first_name')}
                                    </InputLabel>
                                    <OutlinedInput
                                        value={firstName}
                                        onChange={(e) => {
                                            setFirstName(e.target.value)
                                        }}
                                    />
                                    {!validateRes['first_name'] && 
                                        <FormHelperText error>
                                            MAX LENGTH: {paramsRegex['first_name'].maxLength}
                                        </FormHelperText>
                                    }
                                </FormControl>
                            </Grid>
                            <Grid item xs={3}>
                                <FormControl fullWidth variant="outlined">
                                    <InputLabel
                                        style={{
                                            backgroundColor: '#424242',
                                            paddingLeft: 10,
                                            paddingRight: 10
                                        }}
                                        shrink={true}
                                    >
                                    {t('middle_name')}
                                    </InputLabel>
                                    <OutlinedInput
                                        id='editdriver-middlename-input'
                                        value={middleName}
                                        onChange={(e) => {
                                            setMiddleName(e.target.value)
                                        }}
                                    />
                                    {!validateRes['middle_name'] && 
                                        <FormHelperText error>
                                            MAX LENGTH: {paramsRegex['middle_name'].maxLength}
                                        </FormHelperText>
                                    }
                                </FormControl>
                            </Grid>
                            <Grid item xs={3}>
                                <FormControl fullWidth variant="outlined">
                                    <InputLabel
                                        style={{
                                            backgroundColor: '#424242',
                                            paddingLeft: 10,
                                            paddingRight: 10
                                        }}
                                        shrink={true}
                                    >
                                    {t('phone')}
                                    </InputLabel>
                                    <OutlinedInput
                                        value={mobile}
                                        onChange={(e) => {
                                            setMobile(e.target.value)
                                        }}
                                        disabled={openType === 'update'}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={3}>
                                <FormControl fullWidth variant="outlined">
                                    <InputLabel
                                        style={{
                                            backgroundColor: '#424242',
                                            paddingLeft: 10,
                                            paddingRight: 10
                                        }}
                                        shrink={true}
                                    >
                                    {t('email')}
                                    </InputLabel>
                                    <OutlinedInput
                                        value={email}
                                        onChange={(e) => {
                                            setEmail(e.target.value)
                                        }}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={3}>
                                <FormControl fullWidth variant="outlined">
                                    <InputLabel
                                        style={{
                                            backgroundColor: '#424242',
                                            paddingLeft: 10,
                                            paddingRight: 10
                                        }}
                                        shrink={true}
                                    >
                                    {t('address')}
                                    </InputLabel>
                                    <OutlinedInput
                                        value={address}
                                        onChange={(e) => {
                                            setAddress(e.target.value)
                                        }}
                                    />
                                    {!validateRes['address'] && 
                                        <FormHelperText error>
                                            MAX LENGTH: {paramsRegex['address'].maxLength}
                                        </FormHelperText>
                                    }
                                </FormControl>
                            </Grid>
                            <Grid item xs={2}>
                                <FormControl fullWidth variant="outlined">
                                    <InputLabel
                                        style={{
                                            backgroundColor: '#424242',
                                            paddingLeft: 10,
                                            paddingRight: 10
                                        }}
                                        shrink={true}
                                    >
                                    {t('city')}
                                    </InputLabel>
                                    <OutlinedInput
                                        value={city}
                                        onChange={(e) => {
                                            setCity(e.target.value);
                                        }}
                                    />
                                    {!validateRes['city'] && 
                                        <FormHelperText error>
                                            MAX LENGTH: {paramsRegex['city'].maxLength}
                                        </FormHelperText>
                                    }
                                </FormControl>
                            </Grid>
                            <Grid item xs={1}>
                                <FormControl fullWidth variant="outlined">
                                    <InputLabel
                                        style={{
                                            backgroundColor: '#424242',
                                            paddingLeft: 10,
                                            paddingRight: 10
                                        }}
                                        shrink={true}
                                    >
                                    {t('country')}
                                    </InputLabel>
                                    {
                                        (country || driverProfile) &&
                                        <OutlinedInput
                                            value={(driverProfile.basis) ? (driverProfile.basis.country || country) : country}
                                            disabled
                                        />
                                    } 
                                </FormControl>
                            </Grid>
                            <Grid item xs={1}>
                                <FormControl fullWidth variant="outlined">
                                    <InputLabel
                                        style={{
                                            backgroundColor: '#424242',
                                            paddingLeft: 10,
                                            paddingRight: 10
                                        }}
                                        shrink={true}
                                    >
                                    {
                                        t('state_province')
                                    }
                                    </InputLabel> 
                                    {
                                        (province || driverProfile) &&
                                        <OutlinedInput
                                            value={(driverProfile.basis) ? (driverProfile.basis.province || province) : province}
                                            disabled
                                        />
                                    }
                                </FormControl>
                            </Grid>
                            <Grid item xs={2}>
                                <FormControl fullWidth variant="outlined">
                                    <InputLabel
                                        style={{
                                            backgroundColor: '#424242',
                                            paddingLeft: 10,
                                            paddingRight: 10
                                        }}
                                        shrink={true}
                                    >
                                    {t('ZIP')}
                                    </InputLabel>
                                    <OutlinedInput
                                        value={zip}
                                        onChange={(e) => {
                                            setZip(e.target.value)
                                        }}
                                    />
                                    {!validateRes['ZIP'] && 
                                        <FormHelperText error>
                                            MAX LENGTH: {paramsRegex['ZIP'].maxLength}
                                        </FormHelperText>
                                    }
                                </FormControl>
                            </Grid>
                            <Grid item xs={6} container>
                                <Grid item xs={6} style={{marginTop: 10}}>
                                    <FormControl fullWidth variant="outlined">
                                        <InputLabel
                                            style={{
                                                backgroundColor: '#424242',
                                                paddingLeft: 10,
                                                paddingRight: 10
                                            }}
                                            shrink={true}
                                        >
                                        {t('license_no')}
                                        </InputLabel>
                                        <OutlinedInput
                                            value={licenseNum}
                                            onChange={(e) => {
                                                setLicenseNum(e.target.value)
                                            }}
                                        />
                                        {!validateRes['license_no'] && 
                                            <FormHelperText error>
                                                MAX LENGTH: {paramsRegex['license_no'].maxLength}
                                            </FormHelperText>
                                        }
                                    </FormControl>
                                </Grid>
                                <Grid item xs={1} style={{marginTop: 10}}></Grid>
                                <Grid item xs={5} style={{marginTop: 10}}>
                                    <FormControl fullWidth variant="outlined">
                                        <InputLabel
                                            style={{
                                                backgroundColor: '#424242',
                                                paddingLeft: 10,
                                                paddingRight: 10
                                            }}
                                            shrink={true}
                                        >
                                            {t('license_expiry_date')}
                                        </InputLabel>
                                        <OutlinedInput
                                            type="date"
                                            value={expiryDate}
                                            onChange={(e) => {
                                                if(isExpiryDateValid(e.target.value)) {
                                                    setExpiryDate(e.target.value)
                                                }
                                            }}
                                        />
                                        {!validateRes['license_expiry_date'] && 
                                            <FormHelperText error>
                                                MAX LENGTH: {paramsRegex['license_expiry_date'].maxLength}
                                            </FormHelperText>
                                        }
                                    </FormControl>
                                </Grid>
                                <Grid item xs={6} style={{marginTop: 10}}>
                                    <FormControl fullWidth variant="outlined">
                                        <InputLabel
                                            style={{
                                                backgroundColor: '#424242',
                                                paddingLeft: 10,
                                                paddingRight: 10
                                            }}
                                            shrink={true}
                                        >
                                            {t('vehicle_plate')}
                                        </InputLabel>
                                        <OutlinedInput
                                            value={vehiclePlate}
                                            onChange={(e) => {
                                                setVehiclePlate(e.target.value)
                                            }}
                                        />
                                        {!validateRes['vehicle_plate'] && 
                                            <FormHelperText error>
                                                MAX LENGTH: {paramsRegex['vehicle_plate'].maxLength}
                                            </FormHelperText>
                                        }
                                    </FormControl>
                                </Grid>
                                <Grid item xs={1} style={{marginTop: 10}}></Grid>
                                <Grid item xs={5} style={{marginTop: 10}}>
                                    <FormControl fullWidth variant="outlined">
                                        <InputLabel style={{
                                                backgroundColor: '#424242',
                                                paddingLeft: 10,
                                                paddingRight: 10
                                            }}
                                            shrink={true}
                                        >
                                            {t('vehicle_type')}
                                        </InputLabel>
                                        <Select
                                            value={openType === 'add' ? vehicleType : ((vehicleList && vehicleList.length > 0 && driverProfile && driverProfile.driver) ? (vehicleType || driverProfile.driver.vehicle_type) : '')}
                                            onChange={(e) => {
                                                setVehicleType(e.target.value)
                                            }}
                                        >
                                            {
                                                vehicleList &&
                                                vehicleList.length > 0 &&
                                                vehicleList.map((type) => (
                                                    <MenuItem value={type.code}>
                                                        {type.name}
                                                    </MenuItem>
                                                ))
                                            }
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={6} style={{ marginTop: 10 }}>
                                    <FormControl fullWidth variant="outlined">
                                        <InputLabel style={{
                                            backgroundColor: '#424242',
                                            paddingLeft: 10,
                                            paddingRight: 10
                                        }}
                                            shrink={true}
                                        >
                                            {t('fuel_type')}
                                        </InputLabel>
                                        <Select
                                            value={openType === 'add' ? fuelType : ((fuelList && fuelList.length > 0 && driverProfile && driverProfile.driver) ? (fuelType || driverProfile.driver.vehicle_fuel_type) : '')}
                                            onChange={(e) => {
                                                setFuelType(e.target.value)
                                            }}
                                        >
                                            {
                                                fuelList &&
                                                fuelList.length > 0 &&
                                                fuelList.map((type) => (
                                                    <MenuItem value={type.code}>
                                                        {type.name}
                                                    </MenuItem>
                                                ))
                                            }
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={1} style={{ marginTop: 10 }}></Grid>
                                <Grid item xs={5} style={{ marginTop: 10 }}>
                                    <FormControl fullWidth variant="outlined">
                                        <InputLabel
                                            className={classes.labelStyle}
                                            shrink={true}
                                        >
                                        {
                                            t('SSN_SIN')
                                        }
                                        </InputLabel>
                                        <OutlinedInput
                                            value={sin}
                                            onChange={(e) => {
                                                setSin(e.target.value)
                                            }}
                                        />
                                        {!validateRes['SSN_SIN'] && 
                                            <FormHelperText error>
                                                MAX LENGTH: {paramsRegex['SSN_SIN'].maxLength}
                                            </FormHelperText>
                                        }
                                    </FormControl>
                                </Grid>
                            </Grid>
                            <Grid item xs={6}>
                                <FormControl fullWidth variant="outlined">
                                    <InputLabel 
                                        className={classes.labelStyle}
                                        shrink={true}
                                    >
                                        {t('bank_info')}
                                    </InputLabel>
                                    <OutlinedInputTop
                                        startAdornment={<InputAdornment position="start">{t('account_holder')}</InputAdornment>}
                                        labelWidth={60}
                                        value={accountHolder}
                                        onChange={(e) => {
                                            setAccountHoler(e.target.value)
                                        }}
                                    />
                                    <OutlinedInputBetween
                                        startAdornment={<InputAdornment position="start">{t('account_number')}</InputAdornment>}
                                        labelWidth={60}
                                        value={accountNum}
                                        onChange={(e) => {
                                            setAccountNum(e.target.value)
                                        }}
                                    />
                                    <OutlinedInputBetween
                                        startAdornment={<InputAdornment position="start">{t('bank_name_institution_number')}</InputAdornment>}
                                        labelWidth={60}
                                        value={institution}
                                        onChange={(e) => {
                                            setInstitution(e.target.value)
                                        }}
                                    />
                                    <OutlinedInputBetween
                                        startAdornment={<InputAdornment position="start">{t('routing_number_transit_number')}</InputAdornment>}
                                        labelWidth={60}
                                        value={transit}
                                        onChange={(e) => {
                                            setTransit(e.target.value)
                                        }}
                                    />
                                    <OutlinedInputBottom
                                        startAdornment={<InputAdornment position="start">{t('TAX_GST')}</InputAdornment>}
                                        labelWidth={60}
                                        value={gst}
                                        onChange={(e) => {
                                            setGst(e.target.value)
                                        }}
                                    />
                                    {
                                        (!validateRes['account_holder'] ||
                                        !validateRes['account_number'] ||
                                        !validateRes?.bank_name_institution_number ||
                                        !validateRes?.routing_number_transit_number ||
                                        !validateRes['TAX_GST']) && 
                                        <FormHelperText error>
                                            <div>
                                                MAX LENGTH'S : {paramsRegex['account_holder'].maxLength}({t('account_holder')}), {paramsRegex['TAX_GST'].maxLength}({t('TAX_GST')})
                                            </div>
                                            <div>
                                                    EXACT LENGTH'S : {paramsRegex?.account_number?.minLength}-{paramsRegex?.account_number?.maxLength}({t('account_number')}),  
                                                {paramsRegex?.bank_name_institution_number?.exactLength}({t('bank_name_institution_number')}), {paramsRegex?.routing_number_transit_number?.exactLength}({t('routing_number_transit_number')})
                                            </div>
                                        </FormHelperText>
                                    }
                                </FormControl>
                            </Grid>
                            <Grid item xs={6}>
                                <FormControl fullWidth variant="outlined">
                                    <InputLabel 
                                        className={classes.labelStyle}
                                        shrink={true}
                                    >
                                        {t('emergency_contact')}
                                    </InputLabel>
                                    <OutlinedInputTop
                                        startAdornment={<InputAdornment position="start">{t('contract_name')}</InputAdornment>}
                                        labelWidth={60}
                                        value={emergencyName}
                                        onChange={(e) => {
                                            setEmergencyName(e.target.value)
                                        }}
                                    />
                                    <OutlinedInputBottom
                                        startAdornment={<InputAdornment position="start">{t('contract_number')}</InputAdornment>}
                                        labelWidth={60}
                                        value={emergencyNum}
                                        onChange={(e) => {
                                            setEmergencyNum(e.target.value)
                                        }}
                                    />
                                    {
                                        !validateRes['contract_name'] && 
                                        <FormHelperText error>
                                            <div>{t('contract_name')} MAX LENGTH: {paramsRegex['contract_name'].maxLength}</div>
                                        </FormHelperText>
                                    }
                                </FormControl>
                            </Grid>
                            <Grid item container xs={6}>
                                <Grid item container xs={2}></Grid>
                                <Grid 
                                    item container 
                                    xs={7}
                                    style={{
                                        marginTop: 60
                                    }}
                                >
                                    {t('document')}
                                </Grid>
                                <Grid 
                                    item 
                                    container xs={3}
                                    style={{
                                        position: 'relative',
                                        cursor: 'pointer'
                                    }}
                                    onClick={() => {
                                        setPhotoAddOpen(true);
                                    }}
                                >
                                    <div
                                        className={classes.photoGroup}
                                        style={{
                                            top: 12,
                                            right: 0
                                        }}
                                    ></div>
                                    <div
                                        className={classes.photoGroup}
                                        style={{
                                            top: 16,
                                            right: 4
                                        }}
                                    ></div>
                                    <div
                                        className={classes.photoGroup}
                                        style={{
                                            top: 20,
                                            right: 8
                                        }}
                                    ></div>
                                    <div
                                        className={classes.photoGroup}
                                        style={{
                                            top: 24,
                                            right: 12,
                                            backgroundPosition: 'center',
                                            backgroundSize: 'cover',
                                            backgroundRepeat: 'no-repeat'
                                        }}
                                    ></div>
                                    <div
                                        className={classes.photoGroup}
                                        style={{
                                            top: 24,
                                            right: 12,
                                            backgroundColor: 'rgba(0,0,0,0.6)'
                                        }}
                                    ></div>
                                    <div
                                        style={{
                                            position: 'absolute',
                                            right: 52,
                                            top: 24,
                                            fontSize: 64,
                                            fontWeight: 500,
                                            textAlign: 'center',
                                            color: '#fff'
                                        }}
                                    >
                                        +
                                    </div>
                                </Grid>
                            </Grid>
                        </Grid>
                    </div>
                </div>
                <div className={classes.info}>
                    <div className={classes.infoTitle}>
                        {t('additional_info')}
                    </div>
                    <div className={classes.infoContent}>
                    {
                        openType === 'update' &&
                        <Grid container spacing={3} style={{marginBottom: 20}}>
                            <Grid item xs={4}>
                                <FormControl fullWidth variant="outlined">
                                    <InputLabel
                                        className={classes.labelStyle}
                                        shrink={true}
                                    >
                                        {t('ID')}
                                    </InputLabel>
                                    <OutlinedInput
                                        disabled
                                        value={props.driverId}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={4}>
                                <FormControl fullWidth variant="outlined">
                                    <InputLabel
                                        className={classes.labelStyle}
                                        shrink={true}
                                    >
                                        {t('username')}
                                    </InputLabel>
                                    <OutlinedInput
                                        value={username}
                                        disabled
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={4}>
                                <FormControl variant="outlined">
                                    <InputLabel
                                        className={classes.labelStyle}
                                        shrink={true}
                                    >{t('account_status')}</InputLabel>
                                    <OutlinedInput
                                        value={isHired?t('active'):t('deactive')}
                                        endAdornment={
                                            <InputAdornment position="end">
                                                <IconButton
                                                    onClick={handleAccountStatusChange}
                                                    edge="end"
                                                    disabled={!enableDeactivateOrTeam}
                                                >
                                                {
                                                    isHired 
                                                    ? 
                                                            <Button color='primary'>{t('deactivate')}</Button>
                                                    : 
                                                            <Button color='primary'>{t('activate')}</Button>
                                                }
                                                </IconButton>
                                            </InputAdornment>
                                        }
                                        labelWidth={70}
                                    />
                                </FormControl>
                            </Grid>
                        </Grid>
                    }
                        <Grid container spacing={3}>
                            <Grid item xs={4}>
                                <TextField 
                                    fullWidth
                                    select
                                    variant="outlined"
                                    label={t('driver_type')}
                                    value={role} 
                                    onChange={(e)=>{setRole(parseInt(e.target.value))}}
                                    SelectProps={{
                                        native: true,
                                    }}
                                    InputLabelProps={{ shrink: true }}
                                >
                                    {driverTypeList.map((item) => (
                                        <option key={item.label} value={item.value}>
                                            {item.label}
                                        </option>
                                    ))}
                                </TextField>
                            </Grid>
                            <Grid item xs={4}>
                                <div style={{display: 'flex', flexDirection: 'column', textAlign: 'center'}}>
                                    <div style={{textAlign: 'center'}}>{t('sorting_scan')}</div>
                                    <div
                                        className={classes.switch}    
                                    >
                                        <div>{t('off')}</div>
                                        <AntSwitch 
                                            checked={checkedSorting}
                                            onChange={handleSortingChange}
                                            disabled={role===SORTER}
                                        />
                                        <div>{t('on')}</div>
                                    </div>
                                </div>
                            </Grid>
                            <Grid item xs={4}>
                                <div style={{ display: 'flex', flexDirection: 'column', textAlign: 'center' }}>
                                    <div style={{ textAlign: 'center' }}>{t('double_check')}</div>
                                    <div
                                        className={classes.switch}
                                    >
                                        <div>{t('off')}</div>
                                        <AntSwitch
                                            checked={doubleCheck}
                                            onChange={() => setDoubleCheck(!doubleCheck)}
                                            disabled={role === SORTER}
                                        />
                                        <div>{t('on')}</div>
                                    </div>
                                </div>
                            </Grid>
                            {
                                // US-BRANCH-OFF
                                userUS &&
                                <Grid item xs={4}>
                                    <div 
                                        style={{
                                            display: 'flex', 
                                            alignItems: 'center',
                                            cursor: 'pointer'
                                        }}
                                    >
                                        <Checkbox 
                                            color='secondary'
                                            checked={backgroundChecked}
                                            onChange={(e)=>{
                                                if(e.target.checked) {
                                                    setBackgroundChecked(1);
                                                } else {
                                                    setBackgroundChecked(0);
                                                }
                                            }}
                                        />
                                        <div>{t('background_checked')}</div>
                                    </div>
                                </Grid>
                            }
                        </Grid>
                        <Grid container spacing={12} style={{ display: 'flex', marginTop: 30 }}>
                            <TextField
                                select
                                label={t('team')}
                                InputLabelProps={{ shrink: true }}
                                variant="outlined"
                                value={team}
                                onChange={(e) => { setTeam(e.target.value) }}
                                SelectProps={{
                                    native: true,
                                }}
                                style={{ width: 350, paddingRight: 16 }}
                                disabled={disableList || !enableDeactivateOrTeam}
                            >
                                {
                                    teamList.length > 0 && teamList.map((item) => (
                                        <option key=
                                            {item.id} value={item.id}>
                                            {userUS ? item.name_alias : item.name}
                                        </option>
                                    ))
                                }
                            </TextField>
                            <div style={{display: 'flex', justifyContent: 'space-between'}}>
                                <TextField
                                    label={t('customize_team')}
                                    InputLabelProps={{ shrink: true }}
                                    type='string'
                                    variant='outlined'
                                    value={customizeTeam}
                                    onChange={(e)=>{
                                        setCustomizeTeam(e.target.value);
                                        if(e.target.value === '') {
                                            setDisableList(false);
                                        } else {
                                            setDisableList(true);
                                            setTeam(0);
                                        }                               
                                    }}
                                    style={{width: 250}}
                                    disabled={!enableDeactivateOrTeam}
                                />
                                {
                                    userUS &&
                                    <TextField
                                        label={t('team_alias')}
                                        InputLabelProps={{ shrink: true }}
                                        type='string'
                                        variant='outlined'
                                        value={teamAlias}
                                        onChange={(e) => {
                                            setTeamAlias(e.target.value);
                                            if (e.target.value === '') {
                                                setDisableList(false);
                                            } else {
                                                setDisableList(true);
                                                setTeam(0);
                                            }
                                        }}
                                        style={{ width: 250, marginLeft: 20 }}
                                        disabled={!enableDeactivateOrTeam}
                                    />
                                }
                                <div 
                                    style={{
                                        display: 'flex', 
                                        alignItems: 'center', 
                                        marginLeft: 20, 
                                        cursor: 'pointer'
                                    }}

                                >
                                    <Checkbox 
                                        color='secondary'
                                        checked={teamLeader}
                                        onChange={(e)=>{
                                            if(e.target.checked) {
                                                setTeamLeader(1);
                                            } else {
                                                setTeamLeader(0);
                                            }
                                        }}
                                        disabled={!enableDeactivateOrTeam}
                                    />
                                    <div>{t('team_leader')}</div>
                                </div>
                            </div>
                        </Grid>
                        <Grid container spacing={3}>
                            <Grid item xs={12}>
                                <div className={classes.supplies}>
                                    {
                                        supplies.map((supply, index) => (
                                        <div className={classes.supply}>
                                            <div className={classes.supplyMinusAdd}>
                                                <RemoveIcon 
                                                    style={{
                                                        width: 36,
                                                        height: 36,
                                                        color: "#ff9d00"
                                                    }}
                                                    onClick={()=>handleSupply(index,supply, -1)}
                                                />
                                            </div>
                                            <div style={{fontSize: 16,fontWeight: 'bold',  textAlign: 'center', color: '#262626'}}>
                                                {supply.item}: {supply.count}
                                            </div>
                                            <div className={classes.supplyMinusAdd}>
                                                <AddIcon 
                                                    style={{
                                                        width: 36,
                                                        height: 36,
                                                        color: "#ff9d00"
                                                    }}
                                                    onClick={()=>handleSupply(index, supply, 1)}
                                                />
                                            </div>
                                        </div>
                                        ))
                                    }
                                </div>
                            </Grid>
                            <Grid item xs={12} container>
                                <Grid item xs={12} className={classes.addtionalTitle}>{t('salary_type')}</Grid>
                                <Grid item xs={10} container style={{display: 'flex'}}>
                                    {
                                        driverSalaryState &&
                                        driverSalaryState.length > 0 &&
                                        driverSalaryState.map((item, index) => {
                                            if (item.label === "FIX" && item.checked === true) {
                                                return (
                                                    <MenuItem key={item.label + index} style={{paddingLeft: 0}}>
                                                        <MenuItem key={item.label + index} style={{paddingLeft: 0}}>
                                                            <Checkbox
                                                                key={index}
                                                                checked={item.checked}
                                                                onClick={(e) => {
                                                                    setDriverSalaryState(driverSalaryState.map((ele, idx) => idx === index ?
                                                                        {...ele, checked: e.target.checked} :
                                                                        ele)
                                                                    )
                                                                }}
                                                            ></Checkbox>
                                                            <span>{item.label}</span>
                                                        </MenuItem>
                                                        <TextField
                                                            id="salaryTypeFix"
                                                            select
                                                            label={t('please_select')}
                                                            InputLabelProps={{shrink: true}}
                                                            variant="outlined"
                                                            value={salaryTypeFix}
                                                            onChange={(e) => {
                                                                setSalaryTypeFix(e.target.value)
                                                            }}
                                                            SelectProps={{
                                                                native: true,
                                                            }}
                                                            style={{width: 250}}
                                                        >
                                                            {
                                                                driverSalaryTypeFixList &&
                                                                driverSalaryTypeFixList.length > 0 &&
                                                                driverSalaryTypeFixList.map((item) => (
                                                                    <option key={item.value} value={item.value}>
                                                                        {item.label}
                                                                    </option>
                                                                ))
                                                            }
                                                        </TextField>
                                                    </MenuItem>
                                                )
                                            } else {
                                                return (
                                                    <MenuItem key={item.label + index} style={{paddingLeft: 0}}>
                                                        <Checkbox
                                                            key={index}
                                                            checked={item.checked}
                                                            onClick={(e) => {
                                                                setDriverSalaryState(driverSalaryState.map((ele, idx) => idx === index ?
                                                                    {...ele, checked: e.target.checked} :
                                                                    ele)
                                                                )
                                                            }}
                                                        ></Checkbox>
                                                        <span>{item.label}</span>
                                                    </MenuItem>
                                                )
                                            }
                                        })
                                    }
                                </Grid>
                                <Grid item xs={2} container style={{display: 'flex'}}>
                                    <IconButton
                                        variant='contained'
                                        color="primary"
                                        onClick={() => {
                                            setOpenResetPasswordDialog(true)
                                        }}
                                        style={{fontSize: '14px'}}>
                                        {t('reset_password')}
                                    </IconButton>
                                </Grid>
                            </Grid>
                        </Grid>
                    </div>
                </div>
                <div className={classes.buttonGroup}>
                    <ColorButton
                      onClick={handleClose}  
                    >
                        {t('cancel')}
                    </ColorButton>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={handleSubmit}
                    >
                        {t('save')}
                    </Button>
                </div>
            </DialogContent>
            <AddReplaceDocument open={photoAddOpen} handleClose={handlePhotoAddClose} handleUploadDocument={handleUploadDocument} handleCreateDriver={handleCreateDriver} accountId={openType === 'update' ? props.driverId : accountId} type={openType} documentUploadList={documentUploadList}/>
            <FullscreenLoading open={loading}/>
            <ResetPasswordDialog open={openResetPasswordDialog}
                           mobile={mobile}
                           handleResetpasswordDialogClose={handleResetpasswordDialogClose}/>
        </Dialog>
    )
}
export default AddEditDriver;
